import { graphql } from 'react-apollo';

import { QUERY } from '../../../../../../../graphql/queries/accountHoldersQuery';
import { MUTATION } from '../../../../../../../graphql/mutations/removeFinancialAccount';

export default graphql(MUTATION, {
  props: ({ mutate }) => ({
    removeFundingSource: ({ id }) =>
      mutate({
        variables: { id }
      })
  }),
  options: {
    refetchQueries: [{ query: QUERY }],
    fetchPolicy: 'no-cache'
  }
});
